import React from 'react';
import { makeStyles } from '@material-ui/core';
import { EntityOwnershipCard } from '@backstage/plugin-org';

/*
 * The stock card is drawn with the newer Backstage UI card, the cards next to
 * it with `InfoCard`. Its parts carry fixed class names besides the generated
 * ones, which is what the look of `InfoCard` is put onto here: the same
 * surface, the same header with a divider below it, the same title.
 */
const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    '& .bui-Card': {
      background: theme.palette.background.paper,
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[1],
    },
    '& .bui-CardHeader': {
      padding: theme.spacing(2, 2, 2, 2.5),
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    '& .bui-CardHeader h3': {
      fontSize: theme.typography.h5.fontSize,
      fontWeight: theme.typography.fontWeightBold as number,
      fontFamily: theme.typography.fontFamily,
    },
    '& .bui-CardBody': {
      padding: theme.spacing(2),
    },
  },
}));

/**
 * What an entity owns, counted by kind and type - the stock ownership card,
 * looking like the cards around it.
 *
 * Wrapped rather than rebuilt: the grid it draws is not exported by the org
 * plugin, and with it the counting of what a user owns through their groups.
 *
 * @public
 */
export const RTLOwnershipCard = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <EntityOwnershipCard />
    </div>
  );
};
